import { render, staticRenderFns } from "./el-textarea.vue?vue&type=template&id=10384226&scoped=true"
import script from "./el-textarea.vue?vue&type=script&lang=js"
export * from "./el-textarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10384226",
  null
  
)

export default component.exports